import { Stack, Typography } from '@mui/material';

import InfoIcon from '../../assets/icons/InfoIconBorderFill';
import colors from '../../constants/colors';

interface InfoBlockProps {
  text: string | JSX.Element;
  indent?: boolean;
  backgroundColorVariant?: string;
  borderColorVariant?: string;
  fillVariant?: string;
  textSx?: object;
  svgWidth?: object | string;
  svgHeight?: object | string;
}

const InfoBlock = (props: InfoBlockProps) => {
  const { indent = false, svgWidth = '20px', svgHeight = '20px' } = props;

  const marginLeft = indent ? { mobile: 1, tablet: 3 } : 0;
  const marginRight = indent
    ? { mobile: 1, tablet: 2 }
    : { mobile: 0.5, tablet: 1 };
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        backgroundColor: props.backgroundColorVariant || colors.csaaBorder,
        borderColor: props.borderColorVariant || colors.csaaBorder,
        borderRadius: 1,
        py: 1,
        pr: indent ? 3 : 0,
      }}
    >
      <InfoIcon
        sx={{
          alignSelf: 'center',
          ml: marginLeft,
          mr: marginRight,
          width: svgWidth,
          height: svgHeight,
        }}
        fill={props.fillVariant || colors.csaaLightBorder}
      />
      <Typography component="span" sx={props.textSx}>
        {props.text}
      </Typography>
    </Stack>
  );
};

export default InfoBlock;
